import { formatDate } from "./designUtils";

type DesignOptionLike = {
  name: string;
  isTrunk: boolean;
};

export const formatTrunkOptionLabel = (
  baselineDataDate?: string | null
): string => {
  const formatted = formatDate(baselineDataDate);
  return formatted ? `Baseline - ${formatted}` : "Baseline";
};

export const getDesignOptionLabel = (
  option: DesignOptionLike,
  baselineDataDate?: string | null
): string =>
  option.isTrunk ? formatTrunkOptionLabel(baselineDataDate) : option.name;
